
// import React, { useState, useEffect } from 'react';
// import {
//     Button, Dialog, DialogActions, DialogContent, DialogTitle,
//     TextField, Table, TableBody, TableCell, TableContainer,
//     TableHead, TableRow, Paper, Typography, Snackbar,
//     Container
// } from '@mui/material';
// import {
//     getFirestore, collection, getDocs, getDoc, setDoc, addDoc, updateDoc,
//     deleteDoc, doc
// } from 'firebase/firestore';
// import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
// import moment from 'moment';
// import EditIcon from '@mui/icons-material/Edit';
// import { auth } from './firebase'; // Assuming auth is configured in firebase.js
// import DeleteIcon from '@mui/icons-material/Delete';
// import IconButton from '@mui/material/IconButton';
// import Fab from '@mui/material/Fab';
// import AddIcon from '@mui/icons-material/Add';
// import Switch from '@mui/material/Switch';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Card from '@mui/material/Card';
// import CardMedia from '@mui/material/CardMedia';
// import CardContent from '@mui/material/CardContent';
// import CardActions from '@mui/material/CardActions';
// import CloseIcon from '@mui/icons-material/Close';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import { useNavigate } from 'react-router-dom';
// import { Calendar, momentLocalizer } from 'react-big-calendar';
// import { query, where } from 'firebase/firestore';
// import { saveAs } from 'file-saver';
// import Papa from 'papaparse';
// import { Box } from '@mui/material';
// import { useMediaQuery } from '@mui/material';
// import DownloadIcon from '@mui/icons-material/Download';
// import CancelIcon from '@mui/icons-material/Cancel';
// import axios from 'axios';
// import { useAuth } from './AuthContext';
// import { Share as ShareIcon } from '@mui/icons-material';
// import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
// import {   Tabs, Tab,  } from '@mui/material';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday'; // Import the Calendar Icon
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import { Grid } from '@mui/material';
// import GridViewIcon from '@mui/icons-material/GridView';
// import ListIcon from '@mui/icons-material/List';
// // Initialize moment localizer
// const localizer = momentLocalizer(moment);

// const firestore = getFirestore();
// const storage = getStorage();
// const currentUser = auth.currentUser;
// const UploadEvents = () => {
//   const [tabValue, setTabValue] = useState(0); // State to manage active tab
//   const [hostEvents, setHostEvents] = useState([]); // Events hosted by admin
//   const [bookedEvents, setBookedEvents] = useState([]); // Events admin has booked
//   const [showCalendar, setShowCalendar] = useState(false); // Manage calendar view
//   const [showHostCalendar, setShowHostCalendar] = useState(false); // State for Host Event calendar view
//   const [showBookedCalendar, setShowBookedCalendar] = useState(false);
//   const [viewMode, setViewMode] = useState('grid'); // Default to 'grid' view
//   const [loading, setLoading] = useState(true);
//   const firestore = getFirestore();
//   const { currentUser } = useAuth();
//   const navigate = useNavigate();
//   const isMobile = useMediaQuery('(max-width: 768px)');
//   const [view, setView] = useState('grid'); // 'grid' for card view, 'list' for table view
//   const [showCardView, setShowCardView] = useState(true); // State for card/table view
//   const [useCompressedImage, setUseCompressedImage] = useState(true);
//     const [events, setEvents] = useState([]);
//     const [formValues, setFormValues] = useState({
//         eventName: '', eventDate: '', eventTime: '', duration: 60,
//         venue: '', description: '', flyer: null, flyerUrl: '',
//         freePaid: 'Free', // Default value to 'Free'
//         onlineOffline: 'Online', speakerName: '', additionalPoints: ''
//     });
//     const [flyerPreview, setFlyerPreview] = useState(null); // For image preview
//     const [openDialog, setOpenDialog] = useState(false);
//     const [openSnackbar, setOpenSnackbar] = useState(false);
//     const [amount, setAmount] = useState('');
//     const [editMode, setEditMode] = useState(false);
//     const [currentEventId, setCurrentEventId] = useState(null);
//     const [isTableView, setIsTableView] = useState(false); // State to manage view toggle
//     const [confirmationAction, setConfirmationAction] = useState(null);
//     const [selectedSeats, setSelectedSeats] = useState(1); // Assuming you want a default of 1 seat
//     const [bookings, setBookings] = useState({});
//     const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
//     const [openEventDialog, setOpenEventDialog] = useState(false);
//     const [selectedEvent, setSelectedEvent] = useState(null);
//     const [openCalendar, setOpenCalendar] = useState(false); // State to toggle calendar visibility
//     const [visibleEvents, setVisibleEvents] = useState(5);  // Start with 9 events
//     // const isMobile = useMediaQuery('(max-width: 768px)');
//     const [sortedEventss, setSortedEvents] = useState([]);
//     // const [tabValue, setTabValue] = useState(0);

//     // Function to load more events
//     const localizer = momentLocalizer(moment);


//     // const [showCalendar, setShowCalendar] = React.useState(false);

//     const [hoverText, setHoverText] = useState("");
   

    
//     const handleSelectEvent = (event) => {
//         setSelectedEvent(event); // Store the selected event
//         setOpenDialog(true); // Open the dialog
//     };

//     // Handle closing the dialog
//     const handleClose = () => {
//         setOpenDialog(false);
//         setSelectedEvent(null);
//     };

    
//     const generateICSFile = (eventName, eventDate, eventTime, eventDuration, eventVenue) => {
//         const startDateTime = moment(`${eventDate} ${eventTime}`, 'DD-MM-YYYY HH:mm').format('YYYYMMDDTHHmmss');
//         const endDateTime = moment(startDateTime, 'YYYYMMDDTHHmmss').add(eventDuration, 'minutes').format('YYYYMMDDTHHmmss');

//         const icsContent = `
// BEGIN:VCALENDAR
// VERSION:2.0
// PRODID:-//YourCompany//YourApp//EN
// CALSCALE:GREGORIAN
// BEGIN:VEVENT
// UID:${new Date().getTime()}@yourapp.com
// DTSTAMP:${new Date().toISOString().replace(/-|:|\.\d+/g, '')}
// DTSTART:${startDateTime}
// DTEND:${endDateTime}
// SUMMARY:${eventName}
// LOCATION:${eventVenue}
// DESCRIPTION:This is a reminder for the event ${eventName} at ${eventVenue}.
// END:VEVENT
// END:VCALENDAR
//     `;

//         return icsContent.trim();
//     };

//     const handleConfirmationDialog = (action, event) => {
//         if (!currentUser) {
//             navigate('/login');
//         } else {
//             setConfirmationAction(action);
//             setSelectedEvent(event);
//             setOpenConfirmationDialog(true);
//         }
//     };

//     const fetchUserBookings = async () => {
//         if (!currentUser) return; // Ensure the user is authenticated

//         try {
//             const bookingQuery = query(
//                 collection(firestore, 'userBookings'), // Replace 'userBookings' with your Firestore collection name
//                 where('userEmail', '==', currentUser.email) // Filter bookings by the current user's email
//             );

//             const snapshot = await getDocs(bookingQuery); // Fetch the documents that match the query

//             const bookingData = snapshot.docs.reduce((acc, doc) => {
//                 const data = doc.data();
//                 acc[data.eventId] = data.userConfirmed; // Store booking confirmation status with eventId as key
//                 return acc;
//             }, {});

//             setBookings(bookingData); // Update the bookings state with fetched data
//         } catch (error) {
//             console.error('Error fetching user bookings:', error); // Handle any errors
//         }
//     };
//     useEffect(() => {
//         fetchEvents();
//         fetchUserBookings(); // Call the fetchUserBookings function to load user bookings
//     }, [currentUser]); // Re-fetch when currentUser changes



//     const sendOrderConfirmationEmail = async (email, apiKey, orderId, eventName, eventDate, eventTime, eventDuration, eventVenue) => {
//         const icsContent = generateICSFile(eventName, eventDate, eventTime, eventDuration, eventVenue);
    
//         const jsonPayload = {
//             email,
//             subject: `Event Booking Confirmation - ${orderId}`,
//             textbody: `Thank you for booking the event. Your order ID is ${orderId}.`,
//             htmlbody: `
//                 <div style="font-family: Arial, sans-serif; color: #333;">
//                     <h2 style="color: #4CAF50;">Thank you for booking the event!</h2>
//                     <p>Your order ID is <strong>${orderId}</strong>.</p>
//                     <h3>Event Details:</h3>
//                     <p><strong>Event Name:</strong> ${eventName}</p>
//                     <p><strong>Date:</strong> ${eventDate}</p>
//                     <p><strong>Time:</strong> ${eventTime}</p>
//                 </div>`,
//             attachments: [{
//                 filename: `${eventName}.ics`,
//                 content: icsContent,
//                 type: 'text/calendar'
//             }],
//             apiKey,
//         };
    
//         const formData = new FormData();
//         formData.append('jsonPayload', JSON.stringify(jsonPayload));
    
//         try {
//             const response = await axios.post('https://email-a306.onrender.com/send-email', formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 },
//             });
//             if (response.status === 200) {
//                 return 'Email sent successfully!';
//             } else {
//                 return 'Error sending email.';
//             }
//         } catch (error) {
//             return 'Error sending email.';
//         }
//     };
    


//     const sendOrderErrorEmail = async (email, apiKey, orderId, errorMessage) => {
//         const jsonPayload = {
//             email,
//             subject: `Event Cancellation - ${orderId}`,
//             textbody: `Your event order has been successfully cancelled ${orderId}.`,
//             htmlbody:
//                 `<div style="font-family: Arial, sans-serif; color: #333;">
//             <h2 style="color: #f44336;">Event Cancellation</h2>
//             <p>Your event order has been successfully canceled <strong>${orderId}</strong>.</p>
//             <p>Status: ${errorMessage}</p>
//             <p>Please contact our support team for assistance.</p>
//         </div>`,
//             apiKey,
//         };

//         const formData = new FormData();
//         formData.append('jsonPayload', JSON.stringify(jsonPayload));

//         try {
//             const response = await axios.post('https://email-a306.onrender.com/send-email', formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 },
//             });
//             if (response.status === 200) {
//                 return 'Error email sent successfully!';
//             } else {
//                 return 'Error sending error email.';
//             }
//         } catch (error) {
//             if (error.response && error.response.status === 403) {
//                 return 'Invalid API key';
//             } else {
//                 return 'Error sending error email.';
//             }
//         }
//     };





//     const loadMoreEvents = () => {
//         setVisibleEvents(prev => prev + 5);  // Increase the number of visible events by 9
//     };


//     const handleProfileClick = () => {
//         navigate('/user-bookings'); // Navigate to the new page
//     };
//     // Toggle calendar visibility
//     const handleCalendarToggle = () => {
//         setOpenCalendar(!openCalendar);
//     };
//     const handleOpenEventDialog = (event) => {
//         setSelectedEvent(event);
//         setOpenEventDialog(true);
//     };

//     const handleCloseEventDialog = () => {
//         setOpenEventDialog(false);
//         setSelectedEvent(null);
//     };

//     const handleDownloadCSV = async (eventId) => {
//         try {
//             const db = getFirestore();

//             // Fetch user bookings for the event
//             const bookingsRef = collection(db, 'userBookings');
//             const bookingsQuery = query(bookingsRef, where('eventId', '==', eventId), where('userConfirmed', '==', true));
//             const bookingsSnapshot = await getDocs(bookingsQuery);

//             const userIds = bookingsSnapshot.docs.map(doc => doc.data().userEmail);

//             // Check if userIds array is not empty
//             if (userIds.length === 0) {
//                 alert('No user bookings found for this event. CSV download is not available.');
//                 return; // Exit the function if no users are found
//             }

//             // Fetch user profiles
//             const profilesRef = collection(db, 'UserProfileMaster');
//             const profilesQuery = query(profilesRef, where('email', 'in', userIds));
//             const profilesSnapshot = await getDocs(profilesQuery);

//             // Handle case where profilesSnapshot might be empty
//             if (profilesSnapshot.empty) {
//                 console.warn('No user profiles found for the given user IDs.');
//                 return;
//             }

//             const userProfiles = profilesSnapshot.docs.map(doc => doc.data());

//             // Prepare CSV data
//             const csvData = userProfiles.map(profile => ({
//                 Email: profile.email,
//                 PhoneNumber: profile.phoneNumber,
//                 Profession: profile.profession
//             }));

//             // Convert to CSV using PapaParse
//             const csv = Papa.unparse(csvData);

//             // Create a blob and trigger download
//             const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
//             saveAs(blob, `event_${eventId}_bookings.csv`);
//         } catch (error) {
//             console.error('Error generating CSV:', error);
//         }
//     };

//     const handleDownloadICS = (event) => {
//         const icsContent = generateICSFile(
//             event.eventName,
//             moment(event.startTime).format('DD-MM-YYYY'),
//             moment(event.startTime).format('HH:mm'),
//             moment(event.endTime).diff(moment(event.startTime), 'minutes'),
//             event.venue
//         );

//         const blob = new Blob([icsContent], { type: 'text/calendar' });
//         const url = URL.createObjectURL(blob);
//         const link = document.createElement('a');
//         link.href = url;
//         link.download = `${event.eventName}.ics`;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//     };


//     const handleOpenEditDialog = (event) => {
//         setFormValues({
//             eventName: event.eventName,
//             eventDate: moment(event.startTime).format('YYYY-MM-DD'),
//             eventTime: moment(event.startTime).format('HH:mm'),
//             duration: event.duration,
//             venue: event.venue,
//             description: event.description,
//             flyerUrl: event.flyerUrl,
//             freePaid: event.freePaid,
//             onlineOffline: event.onlineOffline,
//             speakerName: event.speakerName,
//             additionalPoints: event.additionalPoints,


//             seatOption: event.seatOption || 'Unlimited',  // New field
//             seatCount: event.seatCount || '',  // New field for limited seats
//             nomineeOption: 'Single',  // Default to Single
//         });
//         setAmount(event.freePaid === 'Paid' ? event.amount : '');
//         setFlyerPreview(event.flyerUrl);
//         setCurrentEventId(event.id);
//         setEditMode(true);
//         setOpenDialog(true);
//     };


//     const fetchEvents = async () => {
//         try {
//             const snapshot = await getDocs(collection(firestore, 'events'));
//             const eventsData = snapshot.docs.map(doc => {
//                 const data = doc.data();
//                 const startTime = data.startTime && data.startTime.toDate ? data.startTime.toDate() : null;
//                 const endTime = data.endTime && data.endTime.toDate ? data.endTime.toDate() : null;
//                 return {
//                     id: doc.id,
//                     ...data,
//                     startTime: data.startTime ? data.startTime.toDate() : null,
//                     endTime: data.endTime ? data.endTime.toDate() : null,
//                     title: data.eventName, // Use the event name as the title
//                     start: startTime ? moment(startTime).toDate() : null,
//                     end: endTime ? moment(endTime).toDate() : null,
//                     creatorId: data.creatorId, // Fetch creatorId from Firestore
//                 };
//             });
//             setEvents(eventsData);
//         } catch (error) {
//             console.error('Error fetching events:', error);
//         }
//     };


//     useEffect(() => {
//         fetchEvents();
//     }, []);


//     const handleInputChange = async (e) => {
//         const { name, value, files } = e.target;
    
//         if (name === 'flyer' && files[0]) {
//             const file = files[0];
    
//             // File Type Validation
//             const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
//             if (!validTypes.includes(file.type)) {
//                 alert('Only JPG, JPEG, and PNG formats are allowed.');
//                 return;  // Exit if the file type is invalid
//             }
    
//             // Handle File Compression or Direct Upload Based on Toggle State
//             if (useCompressedImage) {
//                 const compressedFile = await compressImage(file, 500); // 500KB max size
//                 setFormValues(prev => ({ ...prev, flyer: compressedFile }));
//                 setFlyerPreview(URL.createObjectURL(compressedFile)); // Set preview URL
//             } else {
//                 setFormValues(prev => ({ ...prev, flyer: file }));
//                 setFlyerPreview(URL.createObjectURL(file)); // Set preview URL
//             }
//         } else {
//             // Handle all other form field changes, including eventName
//             setFormValues(prev => ({
//                 ...prev,
//                 [name]: value  // Allow numbers and letters in eventName
//             }));
//         }
    
//         // Handle amount field based on freePaid value
//         if (name === 'freePaid') {
//             setFormValues(prev => ({
//                 ...prev,
//                 amount: value === 'Free' ? '0' : amount  // Reset amount for 'Free' events
//             }));
//         }
    
//         if (name === 'amount') {
//             setAmount(value);
//         }
//     };
    

//     const compressImage = (file, maxSize) => {
//         return new Promise((resolve, reject) => {
//             const reader = new FileReader();
//             reader.readAsDataURL(file);
//             reader.onload = (event) => {
//                 const img = new Image();
//                 img.src = event.target.result;
//                 img.onload = () => {
//                     const canvas = document.createElement('canvas');
//                     const ctx = canvas.getContext('2d');

//                     const maxWidth = 1000;
//                     const scaleFactor = maxWidth / img.width;
//                     canvas.width = maxWidth;
//                     canvas.height = img.height * scaleFactor;

//                     ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

//                     canvas.toBlob((blob) => {
//                         if (blob.size > maxSize * 1024) {
//                             console.error('Compressed file is still too large.');
//                             resolve(file);
//                         } else {
//                             const newFile = new File([blob], file.name, {
//                                 type: file.type,
//                                 lastModified: Date.now(),
//                             });
//                             resolve(newFile);
//                         }
//                     }, file.type, 0.7);
//                 };
//             };
//             reader.onerror = (error) => reject(error);
//         });
//     };

//     const handleRejectEvent = async (eventId) => {
//         try {
//             await deleteDoc(doc(firestore, 'events', eventId));
//             setEvents(events.filter(event => event.id !== eventId));
//         } catch (error) {
//             console.error('Error rejecting event:', error);
//         }
//     };

//     const handleAddEvent = async () => {
//         try {
//             const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
//             const validTextRegex = /^[a-zA-Z0-9\s]*$/; // Allows letters, digits, and spaces

//             const validNumberRegex = /^[0-9]*$/; // Allows only digits
    
//             // Validate flyer type
//             if (formValues.flyer && !validTypes.includes(formValues.flyer.type)) {
//                 alert('Invalid file type. Please upload a JPG, JPEG, or PNG image.');
//                 return; // Stop submission if invalid
//             }
    
//             // Validate event name
//             if (!validTextRegex.test(formValues.eventName) || formValues.eventName.length > 100) {
//                 alert('Event name can only contain letters and should be less than 100 characters.');
//                 return;
//             }
    
//             // Validate venue
//             if (!validTextRegex.test(formValues.venue) || formValues.venue.length > 200) {
//                 alert('Venue can only contain letters and spaces, and should be less than 200 characters.');
//                 return;
//             }
    
//             // Validate description
//             if (formValues.description.length > 500) {
//                 alert('Description should be less than 500 characters.');
//                 return;
//             }
    
//             // Validate duration (minimum 1 minute, maximum 600 minutes)
//             if (!validNumberRegex.test(formValues.duration) || formValues.duration < 1 || formValues.duration > 600) {
//                 alert('Duration must be a number between 1 and 600 minutes.');
//                 return;
//             }
    
//             // Validate seat count (if applicable)
//             if (formValues.seatOption === 'Limited' && (!validNumberRegex.test(formValues.seatCount) || formValues.seatCount < 1)) {
//                 alert('Seat count must be a positive number.');
//                 return;
//             }
    
//             const eventDateTime = moment(`${formValues.eventDate} ${formValues.eventTime}`, 'YYYY-MM-DD HH:mm').toDate();
//             const startTime = eventDateTime;
//             const endTime = new Date(startTime.getTime() + formValues.duration * 60 * 1000);
    
//             // Get the current date and time
//             const currentDate = new Date();
//             const today = currentDate.toISOString().split('T')[0]; // Format: 'YYYY-MM-DD'
    
//             // If the event date is today, check the time
//             if (formValues.eventDate === today && startTime < currentDate) {
//                 alert('Event time cannot be in the past.');
//                 return; // Stop submission if time is invalid
//             }
    
//             // Check if the event date is in the past
//             if (startTime < currentDate) {
//                 alert('Event date and time cannot be in the past.');
//                 return; // Stop submission if the event date is invalid
//             }
    
//             if (isNaN(startTime.getTime())) {
//                 alert('Invalid date or time format.');
//                 return;
//             }
    
//             let flyerUrl = formValues.flyerUrl;
    
//             if (formValues.flyer && formValues.flyer !== flyerUrl) {
//                 const flyerRef = storageRef(storage, `flyers/${formValues.flyer.name}`);
//                 await uploadBytes(flyerRef, formValues.flyer);
//                 flyerUrl = await getDownloadURL(flyerRef);
//             }
    
//             const eventData = {
//                 eventName: formValues.eventName || '',
//                 description: formValues.description || '',
//                 flyerUrl: flyerUrl || '',
//                 startTime: startTime || new Date(),
//                 endTime: endTime || new Date(),
//                 duration: formValues.duration || 60,
//                 venue: formValues.venue || '',
//                 freePaid: formValues.freePaid || 'Free',
//                 amount: formValues.freePaid === 'Paid' ? amount : '0',
//                 onlineOffline: formValues.onlineOffline || 'Online',
//                 speakerName: formValues.speakerName || '',
//                 additionalPoints: formValues.additionalPoints || '',
//                 seatOption: formValues.seatOption || 'Unlimited',
//                 seatCount: formValues.seatOption === 'Limited' ? formValues.seatCount : '1000',
//                 nomineeOption: formValues.nomineeOption || 'Single',
//                 creatorId: currentUser ? currentUser.uid : '', // Ensure UID is valid
//             };
    
//             if (editMode) {
//                 await updateDoc(doc(firestore, 'events', currentEventId), eventData);
//             } else {
//                 await addDoc(collection(firestore, 'events'), eventData);
//             }
    
//             // Reset form and state
//             setFormValues({
//                 eventName: '', eventDate: '', eventTime: '',
//                 duration: 60, venue: '', description: '',
//                 flyer: null, flyerUrl: '',
//                 freePaid: 'Free', onlineOffline: 'Online', speakerName: '', additionalPoints: '',
//                 seatOption: 'Unlimited',
//                 seatCount: '',
//             });
//             setFlyerPreview(null);
//             setEditMode(false);
//             setCurrentEventId(null);
//             setOpenDialog(false);
//             setOpenSnackbar(true);
//             fetchEvents();
//         } catch (error) {
//             console.error('Error saving event:', error);
//         }
//     };
    
    
    



//     const handleOpenDialog = () => setOpenDialog(true);
//     const handleCloseDialog = () => {
//         setOpenDialog(false);
//         setEditMode(false);
//         setCurrentEventId(null);
//         setFlyerPreview(null);
//     };

//     const handleOriginalImageUpload = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             setFormValues(prev => ({ ...prev, flyer: file }));
//             setFlyerPreview(URL.createObjectURL(file));
//         }
//     };


//     const sortedEvents = [...events].sort((a, b) => new Date(a.startTime) - new Date(b.startTime));



//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             // Check for valid file types
//             const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
//             if (!validTypes.includes(file.type)) {
//                 alert('Only JPG, JPEG, and PNG formats are allowed.');
//                 setFormValues((prevValues) => ({ ...prevValues, flyer: null })); // Clear the file
//                 setFlyerPreview(null); // Clear the preview
//                 return;
//             }

//             // If valid, set the file and preview
//             setFormValues((prevValues) => ({ ...prevValues, flyer: file }));
//             setFlyerPreview(URL.createObjectURL(file)); // Generate image preview
//             console.log('File type:', file.type); // Verify file type in console
//         }
//     };


//     const handleConfirmAction = async () => {
//         if (!currentUser || !selectedEvent) return;
    
//         // Optimistic UI update
//         const optimisticBookings = { ...bookings };
//         const bookingRefId = `${currentUser.email}_${selectedEvent.id}`;
    
//         if (confirmationAction === 'book') {
//             optimisticBookings[selectedEvent.id] = true; // Optimistically mark the event as booked
//         } else if (confirmationAction === 'cancel') {
//             optimisticBookings[selectedEvent.id] = false; // Optimistically mark the event as cancelled
//         }
    
//         // Set the updated optimistic state
//         setBookings(optimisticBookings);
    
//         // Close the dialog immediately for a faster user experience
//         setOpenConfirmationDialog(false);
//         handleCloseEventDialog();
    
//         const email = currentUser.email;
//         const apiKey = "qwertyuiop";
//         const orderId = bookingRefId;
//         const eventName = selectedEvent.eventName;
//         const eventDate = moment(selectedEvent.startTime).format('DD-MM-YYYY');
//         const eventTime = moment(selectedEvent.startTime).format('HH:mm');
//         const eventDuration = moment(selectedEvent.endTime).diff(moment(selectedEvent.startTime), 'minutes');
//         const eventVenue = selectedEvent.venue;
    
//         const userProfileRef = doc(firestore, 'UserProfileMaster', currentUser.uid);
//         const userProfileSnap = await getDoc(userProfileRef);
    
//         if (!userProfileSnap.exists()) {
//             console.error("User profile data not found.");
//             return;
//         }
    
//         const { phoneNumber, profession } = userProfileSnap.data();
    
//         setLoading(true);
    
//         try {
//             const bookingRef = doc(firestore, 'userBookings', bookingRefId);
    
//             if (confirmationAction === 'book') {
//                 await setDoc(bookingRef, {
//                     userEmail: currentUser.email,
//                     eventId: selectedEvent.id,
//                     userConfirmed: true,
//                     numberOfSeats: selectedSeats,
//                     phoneNumber: phoneNumber || '',
//                     profession: profession || '',
//                 });
    
//                 sendOrderConfirmationEmail(email, apiKey, orderId, eventName, eventDate, eventTime, eventDuration, eventVenue);
//             } else if (confirmationAction === 'cancel') {
//                 await updateDoc(bookingRef, { userConfirmed: false });
    
//                 sendOrderErrorEmail(email, apiKey, orderId, 'Your booking has been cancelled.');
//             }
    
//             // Fetch updated bookings from Firestore
//             await fetchUserBookings();
    
//         } catch (error) {
//             console.error(`Error during ${confirmationAction}:`, error);
    
//             // Revert optimistic update in case of an error
//             const revertedBookings = { ...bookings };
//             revertedBookings[selectedEvent.id] = confirmationAction === 'book' ? false : true;
//             setBookings(revertedBookings);
    
//             sendOrderErrorEmail(email, apiKey, orderId, error.message);
//         } finally {
//             setLoading(false);
//         }
//     };
    
    
    

//     const handleCancelAction = () => {
//         setOpenConfirmationDialog(false);
//     };

//     const handleShareEvent = (event) => {
//         const eventUrl = `${window.location.origin}/event/${event.id}`; // Generate the dynamic event URL

//         if (navigator.share) {
//             navigator.share({
//                 title: event.eventName,
//                 text: `Check out this event: ${event.eventName}`,
//                 url: eventUrl,
//             })
//                 .then(() => console.log('Event shared successfully!'))
//                 .catch((error) => console.error('Error sharing event:', error));
//         } else {
//             // Fallback: copy the link to the clipboard
//             navigator.clipboard.writeText(eventUrl)
//                 .then(() => {
//                     alert('Event link copied to clipboard!');
//                 })
//                 .catch((error) => console.error('Error copying link to clipboard:', error));
//         }
//     };
//     // Add a useEffect hook to manage state updates and visibility changes
//     useEffect(() => {
//         if (bookings[selectedEvent?.id]) {
//             setOpenSnackbar(false); // Hide snackbar for bookings, if visible.
//         }
//     }, [bookings, selectedEvent]);
//     console.log(  auth.currentUser.uid)
//   // Fetch events hosted by the current user
//   const fetchHostEvents = async () => {
//     try {
//       const q = query(collection(firestore, 'events'), where('creatorId', '==', currentUser.uid));
//       const snapshot = await getDocs(q);
//       const hostedEvents = snapshot.docs.map(doc => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setHostEvents(hostedEvents);
//     } catch (error) {
//       console.error('Error fetching host events:', error);
//     }
//   };

//   // Fetch events booked by the current user
//   const fetchBookedEvents = async () => {
//     try {
//       const q = query(collection(firestore, 'bookings'), where('userId', '==', currentUser.uid));
//       const snapshot = await getDocs(q);
//       const bookedEventsData = snapshot.docs.map(doc => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setBookedEvents(bookedEventsData);
//     } catch (error) {
//       console.error('Error fetching booked events:', error);
//     }
//   };

//   // Effect to fetch events based on the active tab
//   useEffect(() => {
//     setLoading(true);
//     if (tabValue === 0) {
//       fetchHostEvents().then(() => setLoading(false));
//     } else {
//       fetchBookedEvents().then(() => setLoading(false));
//     }
//   }, [tabValue]);

//   // Tab change handler
//   const handleTabChange = (event, newValue) => {
//     setTabValue(newValue);
//   };

//    // Filtered events for each tab based on the user's role

// const createdEvents = events
//   .filter(event => event.creatorId === auth.currentUser.uid)  // Filter events created by the current user
//   .map(event => ({
//     title: event.eventName,
//     start: new Date(event.startTime),
//     end: new Date(event.endTime),
//   }));


//    const bookedEventsCal = events.filter(event => bookings[event.id] === true).map(event => ({
//     title: event.eventName,
//     start: new Date(event.startTime),
//     end: new Date(event.endTime),
//   }));
 

// const renderEvents = (events, isHostView, showTableView) => {
//     return showTableView ? (
//        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
//               <Table>
//                   <TableHead>
//                       <TableRow>
//                           <TableCell>Thumbnail Flyer</TableCell>
//                           <TableCell>Event Name</TableCell>
//                           <TableCell>Date</TableCell>
//                           <TableCell>Time</TableCell>
//                           <TableCell>Duration (mins)</TableCell>
//                           <TableCell>Venue</TableCell>
//                           <TableCell>Free/Paid</TableCell>
//                           <TableCell>Online/Offline</TableCell>
//                           <TableCell>Speaker Name</TableCell>
//                           <TableCell>Capacity</TableCell>
//                           <TableCell>Actions</TableCell>
//                       </TableRow>
//                   </TableHead>
//                   <TableBody>
//                       {sortedEvents
//                           .filter(event => isHostView 
//                               ? event.creatorId === auth.currentUser.uid  // Host view: show only created events
//                               : true  // Booked events: show all events
//                           )
//                           .map(event => (
//                               <TableRow key={event.id}>
//                                   <TableCell>
//                                       <img src={event.flyerUrl} alt="Flyer" style={{ width: '100px', height: 'auto' }} />
//                                   </TableCell>
//                                   <TableCell>{event.eventName}</TableCell>
//                                   <TableCell>{moment(event.startTime).format('D MMM, YYYY')}</TableCell>
//                                   <TableCell>{moment(event.startTime).format('HH:mm')}</TableCell>
//                                   <TableCell>{event.duration}</TableCell>
//                                   <TableCell>{event.venue}</TableCell>
//                                   <TableCell>{event.freePaid}</TableCell>
//                                   <TableCell>{event.onlineOffline}</TableCell>
//                                   <TableCell>{event.speakerName}</TableCell>
//                                   <TableCell>{event.seatOption === 'Limited' ? `${event.seatCount} Seats` : 'Unlimited Seats'}</TableCell>
//                                   <TableCell>
//                                       {isHostView ? (
//                                           <>
//                                               <IconButton color="primary" onClick={() => handleOpenEditDialog(event)}>
//                                                   <EditIcon />
//                                               </IconButton>
//                                               <IconButton color="error" onClick={() => handleRejectEvent(event.id)}>
//                                                   <DeleteIcon />
//                                               </IconButton>
//                                               <IconButton color="default" onClick={(e) => { e.stopPropagation(); handleDownloadCSV(event.id); }}>
//                                                   <DownloadIcon />
//                                               </IconButton>
//                                           </>
//                                       ) : (
//                                           <>
//                                               {bookings[event.id] ? (
//                                                   <>
//                                                       <IconButton color="error" onClick={() => handleConfirmationDialog('cancel', event)}>
//                                                           <CancelIcon />
//                                                       </IconButton>
//                                                       <IconButton color="primary" onClick={() => handleDownloadICS(event)}>
//                                                           <InsertInvitationIcon />
//                                                       </IconButton>
//                                                       <IconButton color="primary" onClick={() => handleShareEvent(event)}>
//                                                           <ShareIcon />
//                                                       </IconButton>
//                                                   </>
//                                               ) : (
//                                                   <Button size="small" color="primary" onClick={(e) => { e.stopPropagation(); handleConfirmationDialog('book', event); }}>
//                                                       Book Now
//                                                   </Button>
//                                               )}
//                                           </>
//                                       )}
//                                   </TableCell>
//                               </TableRow>
//                           ))}
//                   </TableBody>
//               </Table>
//           </TableContainer>
//     ) : (
//       <Grid container spacing={2} sx={{ marginTop: '20px' }}>
//               {sortedEvents
//                   .filter(event => isHostView 
//                       ? event.creatorId === auth.currentUser.uid  // Host view: show only events created by the current user
//                       : true  // Booked events: show all events, whether booked or not
//                   )
//                   .slice(0, visibleEvents)
//                   .map(event => (
//                       <Card key={event.id} style={{ width: '100%', maxWidth: '300px', margin: '20px' }} onClick={() => handleOpenEventDialog(event)}>
//                           <CardMedia
//                               component="img"
//                               height="140"
//                               image={event.flyerUrl}
//                               alt="Flyer"
//                           />
//                           <CardContent>
//                               <Typography gutterBottom variant="h5" component="div">
//                                   {event.eventName}
//                               </Typography>
//                               <Typography variant="body2" color="text.secondary">
//                                   {event.description}
//                               </Typography>
//                               <Typography variant="body2" color="text.secondary">
//                                   {moment(event.startTime).format('D MMM, YYYY')} at {moment(event.startTime).format('HH:mm')}
//                               </Typography>
//                               <Typography variant="body2" color="text.secondary">
//                                   {event.venue}
//                               </Typography>
//                               <Typography variant="body2" color="text.secondary">
//                                   {event.freePaid} | {event.onlineOffline}
//                               </Typography>
//                               <Typography variant="body2" color="text.secondary">
//                                   {event.seatOption === 'Limited' ? `Seats: ${event.seatCount}` : 'Unlimited Seats'}
//                               </Typography>
//                           </CardContent>
  
//                           <CardActions>
//   {isHostView ? (
//     <>
//       <IconButton color="primary" onClick={(e) => { e.stopPropagation(); handleOpenEditDialog(event); }}>
//         <EditIcon />
//       </IconButton>
//       <IconButton color="error" onClick={(e) => { e.stopPropagation(); handleRejectEvent(event.id); }}>
//         <DeleteIcon />
//       </IconButton>
//       <IconButton color="default" onClick={(e) => { e.stopPropagation(); handleDownloadCSV(event.id); }}>
//         <DownloadIcon />
//       </IconButton>
//     </>
//   ) : (
//     <>
//       {bookings[event.id] ? (
//         <>
//           <IconButton color="error" onClick={(e) => { e.stopPropagation(); handleConfirmationDialog('cancel', event); }}>
//             <CancelIcon />
//           </IconButton>
//           <IconButton color="primary" onClick={() => handleDownloadICS(event)}>
//             <InsertInvitationIcon />
//           </IconButton>
//           <IconButton color="primary" onClick={() => handleShareEvent(event)}>
//             <ShareIcon />
//           </IconButton>
//         </>
//       ) : (
//         <Button size="small" color="primary" onClick={(e) => { e.stopPropagation(); handleConfirmationDialog('book', event); }}>
//           Book Now
//         </Button>
//       )}
//     </>
//   )}
// </CardActions>

//                       </Card>
//                   ))}
//                    <Dialog open={openEventDialog} onClose={handleCloseEventDialog}>
//                    <DialogTitle>
//                        {selectedEvent?.eventName}
//                        <Button
//                           onClick={handleCloseEventDialog}
//                           style={{ position: 'absolute', top: 8, right: 8 }}
//                       >
//                           <CloseIcon />
//                       </Button>
//                   </DialogTitle>
//                   <DialogContent>
//                       <img
//                           src={selectedEvent?.flyerUrl}
//                           alt={selectedEvent?.eventName}
//                           style={{ width: '100%', maxHeight: '200px', objectFit: 'contain', marginBottom: '20px' }}
//                       />
//                       <Typography variant="body1" gutterBottom>
//                           {moment(selectedEvent?.startTime).format('DD-MM-YYYY')} - {moment(selectedEvent?.startTime).format('HH:mm')} - {selectedEvent?.venue}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary" gutterBottom>
//                           Duration: {moment(selectedEvent?.endTime).diff(moment(selectedEvent?.startTime), 'minutes')} mins
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary" gutterBottom>
//                           {selectedEvent?.description}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary" gutterBottom>
//                           Free/Paid: {selectedEvent?.freePaid}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary" gutterBottom>
//                           Online/Offline: {selectedEvent?.inlineOffline}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary" gutterBottom>
//                           Speaker Name: {selectedEvent?.speakerName}
//                       </Typography>
//                       <Typography variant="body2" color="textSecondary" gutterBottom>
//                           Additional Points: {selectedEvent?.additionalPoints}
//                       </Typography>
//                   </DialogContent>
//                   <DialogActions>
//                       <Button size="small" color="primary" onClick={handleCloseEventDialog}>
//                           Close
//                       </Button>
//                   </DialogActions>
//                   <DialogActions>
//                       {bookings[selectedEvent?.id] ? (
//                           <IconButton
//                               color="secondary"
//                               onClick={() => handleConfirmationDialog('cancel', selectedEvent)}
//                           >
//                               <CancelIcon />
//                           </IconButton>
//                       ) : (
//                           <Button
//                               size="small"
//                               color="primary"
//                               onClick={() => handleConfirmationDialog('book', selectedEvent)}
//                           >
//                               Book Now!
//                           </Button>
//                       )}
//                   </DialogActions>
  
//               </Dialog>
  
  
//               <Dialog open={openConfirmationDialog} onClose={handleCancelAction}>
//                   <DialogTitle>
//                       {confirmationAction === 'book' ? 'Are you sure you want to book this event?' : 'Are you sure you want to cancel this booking?'}
//                   </DialogTitle>
//                   <DialogActions>
//                       <Button onClick={handleCancelAction} color="secondary">
//                           Cancel
//                       </Button>
//                       <Button onClick={handleConfirmAction} color="primary">
//                           Confirm
//                       </Button>
//                   </DialogActions>
//               </Dialog>
//           </Grid>
//     );
//   };
  
// // Fetch all events from Firestore
// useEffect(() => {
//     const fetchAllEvents = async () => {
        
//         const eventSnapshot = await getDocs(collection(firestore, 'events'));
//         const events = eventSnapshot.docs.map(doc => ({
//             id: doc.id,
            
//             ...doc.data()
//         }));
//         setAllEvents(events);  // Store all events in state
//     };

//     fetchAllEvents();
// }, []);
// const [allEvents, setAllEvents] = useState([]); // Store all events

// console.log('Created Events:', createdEvents);
// console.log('All Events:', allEvents);

//   return (
//     <Container>
//       {/* Title */}
//       <Typography variant="h5" sx={{ marginBottom: '20px', textAlign: 'center' }}>
//         Events
//       </Typography>
//       <div style={{ position: 'fixed', bottom: '18px', right: '16px' }}>
//                 <Fab
//                     color="primary"
//                     onClick={handleOpenDialog}
//                     style={{
//                         width: '56px',   // Set width equal to height for a circular button
//                         height: '56px',  // Height remains the same
//                         borderRadius: '50%'  // Make it fully circular by setting borderRadius to 50%
//                     }}
//                 >
//                     <AddIcon />
//                 </Fab>
//             </div>
//       {/* Tabs */}
//       <Tabs value={tabValue} onChange={handleTabChange} centered>
//         <Tab label="Host Event" />
//         <Tab label="Book Event" />
//       </Tabs>
//   {/* Host Event Tab */}
//   <TabPanel value={tabValue} index={0}>
//   <Box sx={{ marginTop: '20px', padding: '20px' }}>
//   {/* View selection buttons */}
//   <Grid container display="flex" justifyContent="center" alignItems="center">
//     {/* Grid View Button */}
//     <IconButton 
//       color={view === 'grid' ? 'primary' : 'default'} 
//       onClick={() => setView('grid')}
//     >
//       <GridViewIcon />
//     </IconButton>

//     {/* List View Button */}
//     <IconButton 
//       color={view === 'list' ? 'primary' : 'default'} 
//       onClick={() => setView('list')}
//     >
//       <ListIcon />
//     </IconButton>

//     {/* Calendar View Button */}
//     <IconButton
//       color={view === 'calendar' ? 'primary' : 'default'}
//       onClick={() => setView('calendar')}
//     >
//       <CalendarTodayIcon />
//     </IconButton>
//   </Grid>

//   {/* Render the views based on the selected option */}
//   {view === 'grid' && renderEvents(createdEvents, true, false)} {/* Grid View for created events */}
//   {view === 'list' && renderEvents(createdEvents, true, true)} {/* List View for created events */}

//   {/* Calendar View for Host's Created Events */}
//   {view === 'calendar' && (
//     <Calendar
//       localizer={localizer}
//       events={createdEvents} // Pass the filtered events
//       startAccessor="start"
//       endAccessor="end"
//       style={{ height: 500, margin: '20px 0' }}
//     />
//   )}
// </Box>

//     </TabPanel>

//     <TabPanel value={tabValue} index={1}>
//     <Box sx={{ marginTop: '20px', padding: '20px' }}>
//   {/* Toggle Switch for View Selection and Calendar Toggle */}
//   <Grid container display="flex" justifyContent="center" alignItems="center">
//     {/* Grid (Card) View Icon */}
//     <IconButton 
//       color={view === 'grid' ? 'primary' : 'default'} 
//       onClick={() => setView('grid')} // Set Grid (Card) View
//     >
//       <GridViewIcon />
//     </IconButton>

//     {/* List (Table) View Icon */}
//     <IconButton 
//       color={view === 'list' ? 'primary' : 'default'} 
//       onClick={() => setView('list')} // Set List (Table) View
//     >
//       <ListIcon />
//     </IconButton>

//     {/* Calendar View Icon */}
//     <IconButton 
//       color={view === 'calendar' ? 'primary' : 'default'} 
//       onClick={() => setView('calendar')} // Set Calendar View
//     >
//       <CalendarTodayIcon />
//     </IconButton>
//   </Grid>

//   {/* Conditional Rendering for Views */}

//   {/* Grid (Card) View */}
//   {view === 'grid' && renderEvents(allEvents, false, false)} {/* Pass parameters for Card (Grid) view */}

//   {/* List (Table) View */}
//   {view === 'list' && renderEvents(allEvents, false, true)} {/* Pass parameters for Table (List) view */}

//   {/* Calendar View */}
//   {view === 'calendar' && (
    
//     <Calendar
//       localizer={localizer}
//       events={bookedEventsCal} // Pass the filtered events
//       startAccessor="start"
//       endAccessor="end"
//       style={{ height: 500, margin: '20px 0' }}
      
//     />


//   )}
  
// </Box>


//     </TabPanel>
      

//       <Dialog open={openDialog} onClose={handleCloseDialog}>
//                 <DialogTitle>Event Details</DialogTitle>
//                 <DialogContent>
//                     <TextField
//                         autoFocus
//                         margin="dense"
//                         name="eventName"
//                         label="Event Name"
//                         type="text"
//                         fullWidth
//                         variant="outlined"
//                         value={formValues.eventName}
//                         onChange={handleInputChange}
//                     />
//                     <TextField
//     margin="dense"
//     label="Event Date"
//     type="date"
//     fullWidth
//     name="eventDate"
//     value={formValues.eventDate}
//     onChange={handleInputChange}
//     InputLabelProps={{ shrink: true }}
//     inputProps={{
//         min: new Date().toISOString().split("T")[0]  // Restrict to today and future dates
//     }}
// />
// <TextField
//     margin="dense"
//     label="Event Time"
//     type="time"
//     fullWidth
//     name="eventTime"
//     value={formValues.eventTime}
//     onChange={handleInputChange}
//     InputLabelProps={{ shrink: true }}
//     inputProps={{
//         // Check if selected date is today
//         min: formValues.eventDate === new Date().toISOString().split("T")[0]
//           ? new Date().toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })
//           : '00:00'  // Allow all times for future dates
//     }}
// />


//                     <TextField
//                         margin="dense"
//                         name="duration"
//                         label="Duration (minutes)"
//                         type="number"
//                         fullWidth
//                         variant="outlined"
//                         value={formValues.duration}
//                         onChange={handleInputChange}
//                     />
//                     <TextField
//                         margin="dense"
//                         name="venue"
//                         label="Venue"
//                         type="text"
//                         fullWidth
//                         variant="outlined"
//                         multiline
//                         rows={2} // Set to 2 lines
//                         value={formValues.venue}
//                         onChange={handleInputChange}
//                     />
//                     <TextField
//                         margin="dense"
//                         name="speakerName"
//                         label="Speaker Name"
//                         type="text"
//                         fullWidth
//                         variant="outlined"
//                         value={formValues.speakerName}
//                         onChange={handleInputChange}
//                     />
//                     <TextField
//                         margin="dense"
//                         name="description"
//                         label="Description"
//                         type="text"
//                         fullWidth
//                         variant="outlined"
//                         multiline
//                         rows={2} // Set to 2 lines
//                         value={formValues.description}
//                         onChange={handleInputChange}
//                     />

//                     <TextField
//                         margin="dense"
//                         name="freePaid"
//                         label="Free/Fees"
//                         select
//                         fullWidth
//                         value={formValues.freePaid}
//                         onChange={handleInputChange}
//                         SelectProps={{ native: true }}
//                     >
//                         <option value="Free">Free</option>
//                         <option value="Fees">Fees</option>
//                     </TextField>
//                     {formValues.freePaid === 'Fees' && (
//                         <TextField
//                             margin="dense"
//                             name="amount"
//                             label="Amount"
//                             type="number"
//                             fullWidth
//                             variant="outlined"
//                             value={amount}
//                             onChange={handleInputChange}
//                         />
//                     )}

//                     <TextField
//                         margin="dense"
//                         name="onlineOffline"
//                         label="Online/Offline"
//                         select
//                         fullWidth
//                         value={formValues.onlineOffline}
//                         onChange={handleInputChange}
//                         SelectProps={{ native: true }}
//                     >
//                         <option value="Online">Online</option>
//                         <option value="Offline">Offline</option>
//                     </TextField>

//                     <TextField
//                         margin="dense"
//                         name="seatOption"
//                         label="Seat Option"
//                         select
//                         fullWidth
//                         value={formValues.seatOption}
//                         onChange={handleInputChange}
//                         SelectProps={{ native: true }}
//                     >
//                         <option value="Unlimited">Unlimited Seats</option>
//                         <option value="Limited">Limited Seats</option>
//                     </TextField>

//                     {formValues.seatOption === 'Limited' && (
//                         <TextField
//                             margin="dense"
//                             name="seatCount"
//                             label="Number of Seats"
//                             type="number"
//                             fullWidth
//                             variant="outlined"
//                             value={formValues.seatCount}
//                             onChange={handleInputChange}
//                         />
//                     )}
//                     <TextField
//                         margin="dense"
//                         name="nomineeOption"
//                         label="Nominee Option"
//                         select
//                         fullWidth
//                         value={formValues.nomineeOption}
//                         onChange={handleInputChange}
//                         SelectProps={{ native: true }}
//                     >
//                         <option value="Single">Single Nominee</option>
//                         <option value="Multiple">Multiple Nominees</option>
//                     </TextField>


//                     <TextField
//                         margin="dense"
//                         name="additionalPoints"
//                         label="Additional Points"
//                         type="text"
//                         fullWidth
//                         variant="outlined"
//                         multiline
//                         rows={2} // Set to 2 lines
//                         value={formValues.additionalPoints}
//                         onChange={handleInputChange}
//                     />
                    
//                     <input
//                         name="flyer"
//                         type="file"
//                         accept="image/jpeg, image/png, image/jpg" // Specify valid formats here
//                         onChange={handleFileChange} // Use the file-specific handler
//                         style={{ marginBottom: '16px' }}
//                     />

//                     {flyerPreview && <img src={flyerPreview} alt="Flyer Preview" style={{ width: '100px', height: 'auto', marginBottom: '16px' }} />}
//                     <FormControlLabel
//                         control={<Switch checked={useCompressedImage} onChange={(e) => setUseCompressedImage(e.target.checked)} />}
//                         label="Upload Compressed Image"
//                     />


//                 </DialogContent>
              
//                 <DialogActions>
//                     <Button onClick={handleCloseDialog} color="primary">Cancel</Button>
//                     <Button
//                         onClick={handleAddEvent}
//                         color="primary"
//                         disabled={
//                             // Disable if flyer is present and is not of a valid type
//                             formValues.flyer && !['image/jpeg', 'image/png', 'image/jpg'].includes(formValues.flyer.type)
//                         }
//                     >
//                         {editMode ? 'Save' : 'Add Event'}
//                     </Button>
//                 </DialogActions>


//             </Dialog>
//             <Snackbar
//                 open={openSnackbar}
//                 autoHideDuration={3000}
//                 onClose={() => setOpenSnackbar(false)}
//                 message="Event added successfully!"
//             />

//             {visibleEvents < events.length && (
//                 <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
//                     <Button variant="contained" color="primary" onClick={loadMoreEvents}>
//                         Load More
//                     </Button>
//                 </Box>
//             )}
//     </Container>
//   );
// };

// // TabPanel component to show or hide tabs content based on index
// function TabPanel({ children, value, index, ...other }) {
//   return (
//     <div role="tabpanel" hidden={value !== index} {...other}>
//       {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
//     </div>
//   );
// }

// export default UploadEvents;




import React, { useState, useEffect } from 'react';
import {
    Button, Dialog, DialogActions, DialogContent, DialogTitle,
    TextField, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Paper, Typography, Snackbar,
    Container
} from '@mui/material';
import {
    getFirestore, collection, getDocs, getDoc, setDoc, addDoc, updateDoc,
    deleteDoc, doc
} from 'firebase/firestore';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import moment from 'moment';
import EditIcon from '@mui/icons-material/Edit';
import { auth } from './firebase'; // Assuming auth is configured in firebase.js
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import CloseIcon from '@mui/icons-material/Close';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useNavigate } from 'react-router-dom';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import { query, where } from 'firebase/firestore';
import { saveAs } from 'file-saver';
import { Box } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import CancelIcon from '@mui/icons-material/Cancel';
import axios from 'axios';
import { useAuth } from './AuthContext';
import { Share as ShareIcon } from '@mui/icons-material';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import {   Tabs, Tab,  } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'; // Import the Calendar Icon
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Grid } from '@mui/material';
import GridViewIcon from '@mui/icons-material/GridView';
import ListIcon from '@mui/icons-material/List';

import QrCodeIcon from '@mui/icons-material/QrCode';
import { downloadQRCode } from './QRCodeGenerator';
import { downloadQRCodeWrapper } from './QRCodeGenerator';
// Initialize moment localizer
const localizer = momentLocalizer(moment);

const firestore = getFirestore();
const storage = getStorage();
const currentUser = auth.currentUser;
const UploadEvents = () => {
  const [tabValue, setTabValue] = useState(0); // State to manage active tab
  const [hostEvents, setHostEvents] = useState([]); // Events hosted by admin
  const [bookedEvents, setBookedEvents] = useState([]); // Events admin has booked
  const [showCalendar, setShowCalendar] = useState(false); // Manage calendar view
  const [showHostCalendar, setShowHostCalendar] = useState(false); // State for Host Event calendar view
  const [showBookedCalendar, setShowBookedCalendar] = useState(false);
  const [viewMode, setViewMode] = useState('grid'); // Default to 'grid' view
  const [loading, setLoading] = useState(true);
  const firestore = getFirestore();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [view, setView] = useState('grid'); // 'grid' for card view, 'list' for table view
  const [showCardView, setShowCardView] = useState(true); // State for card/table view
  const [useCompressedImage, setUseCompressedImage] = useState(true);
    const [events, setEvents] = useState([]);
    const [formValues, setFormValues] = useState({
        eventName: '', eventDate: '', eventTime: '', duration: 60,
        venue: '', description: '', flyer: null, flyerUrl: '',
        freePaid: 'Free', // Default value to 'Free'
        onlineOffline: 'Online', speakerName: '', additionalPoints: ''
    });
    const [flyerPreview, setFlyerPreview] = useState(null); // For image preview
    const [openDialog, setOpenDialog] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [amount, setAmount] = useState('');
    const [editMode, setEditMode] = useState(false);
    const [currentEventId, setCurrentEventId] = useState(null);
    const [isTableView, setIsTableView] = useState(false); // State to manage view toggle
    const [confirmationAction, setConfirmationAction] = useState(null);
    const [selectedSeats, setSelectedSeats] = useState(1); // Assuming you want a default of 1 seat
    const [bookings, setBookings] = useState({});
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
    const [openEventDialog, setOpenEventDialog] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [openCalendar, setOpenCalendar] = useState(false); // State to toggle calendar visibility
    const [visibleEvents, setVisibleEvents] = useState(5);  // Start with 9 events
    // const isMobile = useMediaQuery('(max-width: 768px)');
    const [sortedEventss, setSortedEvents] = useState([]);
    // const [tabValue, setTabValue] = useState(0);

    // Function to load more events
    const localizer = momentLocalizer(moment);


    // const [showCalendar, setShowCalendar] = React.useState(false);

    const [hoverText, setHoverText] = useState("");
   

    
    const handleSelectEvent = (event) => {
        setSelectedEvent(event); // Store the selected event
        setOpenDialog(true); // Open the dialog
    };

    // Handle closing the dialog
    const handleClose = () => {
        setOpenDialog(false);
        setSelectedEvent(null);
    };

    
    const generateICSFile = (eventName, eventDate, eventTime, eventDuration, eventVenue) => {
        const startDateTime = moment(`${eventDate} ${eventTime}`, 'DD-MM-YYYY HH:mm').format('YYYYMMDDTHHmmss');
        const endDateTime = moment(startDateTime, 'YYYYMMDDTHHmmss').add(eventDuration, 'minutes').format('YYYYMMDDTHHmmss');

        const icsContent = `
BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//YourCompany//YourApp//EN
CALSCALE:GREGORIAN
BEGIN:VEVENT
UID:${new Date().getTime()}@yourapp.com
DTSTAMP:${new Date().toISOString().replace(/-|:|\.\d+/g, '')}
DTSTART:${startDateTime}
DTEND:${endDateTime}
SUMMARY:${eventName}
LOCATION:${eventVenue}
DESCRIPTION:This is a reminder for the event ${eventName} at ${eventVenue}.
END:VEVENT
END:VCALENDAR
    `;

        return icsContent.trim();
    };

    const handleConfirmationDialog = (action, event) => {
        if (!currentUser) {
            navigate('/login');
        } else {
            setConfirmationAction(action);
            setSelectedEvent(event);
            setOpenConfirmationDialog(true);
        }
    };

    const fetchUserBookings = async () => {
        if (!currentUser) return; // Ensure the user is authenticated

        try {
            const bookingQuery = query(
                collection(firestore, 'userBookings'), // Replace 'userBookings' with your Firestore collection name
                where('userEmail', '==', currentUser.email) // Filter bookings by the current user's email
            );

            const snapshot = await getDocs(bookingQuery); // Fetch the documents that match the query

            const bookingData = snapshot.docs.reduce((acc, doc) => {
                const data = doc.data();
                acc[data.eventId] = data.userConfirmed; // Store booking confirmation status with eventId as key
                return acc;
            }, {});

            setBookings(bookingData); // Update the bookings state with fetched data
        } catch (error) {
            console.error('Error fetching user bookings:', error); // Handle any errors
        }
    };
    useEffect(() => {
        fetchEvents();
        fetchUserBookings(); // Call the fetchUserBookings function to load user bookings
    }, [currentUser]); // Re-fetch when currentUser changes



    const sendOrderConfirmationEmail = async (email, apiKey, orderId, eventName, eventDate, eventTime, eventDuration, eventVenue) => {
        const icsContent = generateICSFile(eventName, eventDate, eventTime, eventDuration, eventVenue);
    
        const jsonPayload = {
            email,
            subject: `Event Booking Confirmation - ${orderId}`,
            textbody: `Thank you for booking the event. Your order ID is ${orderId}.`,
            htmlbody: `
                <div style="font-family: Arial, sans-serif; color: #333;">
                    <h2 style="color: #4CAF50;">Thank you for booking the event!</h2>
                    <p>Your order ID is <strong>${orderId}</strong>.</p>
                    <h3>Event Details:</h3>
                    <p><strong>Event Name:</strong> ${eventName}</p>
                    <p><strong>Date:</strong> ${eventDate}</p>
                    <p><strong>Time:</strong> ${eventTime}</p>
                </div>`,
            attachments: [{
                filename: `${eventName}.ics`,
                content: icsContent,
                type: 'text/calendar'
            }],
            apiKey,
        };
    
        const formData = new FormData();
        formData.append('jsonPayload', JSON.stringify(jsonPayload));
    
        try {
            const response = await axios.post('https://email-a306.onrender.com/send-email', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.status === 200) {
                return 'Email sent successfully!';
            } else {
                return 'Error sending email.';
            }
        } catch (error) {
            return 'Error sending email.';
        }
    };
    


    const sendOrderErrorEmail = async (email, apiKey, orderId, errorMessage) => {
        const jsonPayload = {
            email,
            subject: `Event Cancellation - ${orderId}`,
            textbody: `Your event order has been successfully cancelled ${orderId}.`,
            htmlbody:
                `<div style="font-family: Arial, sans-serif; color: #333;">
            <h2 style="color: #f44336;">Event Cancellation</h2>
            <p>Your event order has been successfully canceled <strong>${orderId}</strong>.</p>
            <p>Status: ${errorMessage}</p>
            <p>Please contact our support team for assistance.</p>
        </div>`,
            apiKey,
        };

        const formData = new FormData();
        formData.append('jsonPayload', JSON.stringify(jsonPayload));

        try {
            const response = await axios.post('https://email-a306.onrender.com/send-email', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.status === 200) {
                return 'Error email sent successfully!';
            } else {
                return 'Error sending error email.';
            }
        } catch (error) {
            if (error.response && error.response.status === 403) {
                return 'Invalid API key';
            } else {
                return 'Error sending error email.';
            }
        }
    };





    const loadMoreEvents = () => {
        setVisibleEvents(prev => prev + 5);  // Increase the number of visible events by 9
    };


    const handleProfileClick = () => {
        navigate('/user-bookings'); // Navigate to the new page
    };
    // Toggle calendar visibility
    const handleCalendarToggle = () => {
        setOpenCalendar(!openCalendar);
    };
    const handleOpenEventDialog = (event) => {
        setSelectedEvent(event);
        setOpenEventDialog(true);
    };

    const handleCloseEventDialog = () => {
        setOpenEventDialog(false);
        setSelectedEvent(null);
    };

    // const handleDownloadCSV = async (eventId) => {
    //     try {
    //         const db = getFirestore();

    //         // Fetch user bookings for the event
    //         const bookingsRef = collection(db, 'userBookings');
    //         const bookingsQuery = query(bookingsRef, where('eventId', '==', eventId), where('userConfirmed', '==', true));
    //         const bookingsSnapshot = await getDocs(bookingsQuery);

    //         const userIds = bookingsSnapshot.docs.map(doc => doc.data().userEmail);

    //         // Check if userIds array is not empty
    //         if (userIds.length === 0) {
    //             alert('No user bookings found for this event. CSV download is not available.');
    //             return; // Exit the function if no users are found
    //         }

    //         // Fetch user profiles
    //         const profilesRef = collection(db, 'UserProfileMaster');
    //         const profilesQuery = query(profilesRef, where('email', 'in', userIds));
    //         const profilesSnapshot = await getDocs(profilesQuery);

    //         // Handle case where profilesSnapshot might be empty
    //         if (profilesSnapshot.empty) {
    //             console.warn('No user profiles found for the given user IDs.');
    //             return;
    //         }

    //         const userProfiles = profilesSnapshot.docs.map(doc => doc.data());

    //         // Prepare CSV data
    //         const csvData = userProfiles.map(profile => ({
    //             Email: profile.email,
    //             PhoneNumber: profile.phoneNumber,
    //             Profession: profile.profession
    //         }));

    //         // Convert to CSV using PapaParse
    //         const csv = Papa.unparse(csvData);

    //         // Create a blob and trigger download
    //         const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    //         saveAs(blob, `event_${eventId}_bookings.csv`);
    //     } catch (error) {
    //         console.error('Error generating CSV:', error);
    //     }
    // };

    // const handleDownloadCSV = async (eventId) => {
    //     try {
    //         const db = getFirestore();
    
    //         // Fetch user bookings for the event
    //         const bookingsRef = collection(db, 'userBookings');
    //         const bookingsQuery = query(bookingsRef, where('eventId', '==', eventId), where('userConfirmed', '==', true));
    //         const bookingsSnapshot = await getDocs(bookingsQuery);
    
    //         const userEmails = bookingsSnapshot.docs.map(doc => doc.data().userEmail);
    
    //         // Check if userEmails array is not empty
    //         if (userEmails.length === 0) {
    //             alert('No user bookings found for this event. CSV download is not available.');
    //             return; // Exit the function if no users are found
    //         }
    
    //         // Fetch user profiles
    //         const profilesRef = collection(db, 'UserProfileMaster');
    //         const profilesQuery = query(profilesRef, where('email', 'in', userEmails));
    //         const profilesSnapshot = await getDocs(profilesQuery);
    
    //         if (profilesSnapshot.empty) {
    //             console.warn('No user profiles found for the given user IDs.');
    //             return;
    //         }
    
    //         const userProfiles = profilesSnapshot.docs.map(doc => doc.data());
    
    //         // Fetch attendance records
    //         const attendanceRef = collection(db, 'attendance'); // Assuming 'attendanceRecords' is the collection storing attendance
    //         const attendanceQuery = query(attendanceRef, where('eventId', '==', eventId));
    //         const attendanceSnapshot = await getDocs(attendanceQuery);
    
    //         const attendanceMap = new Map();
    //         attendanceSnapshot.docs.forEach(doc => {
    //             const data = doc.data();
    //             attendanceMap.set(data.email, { attended: true, ...data });
    //         });
    
    //         // Prepare CSV data with attendance information
    //         const csvData = userProfiles.map(profile => {
    //             const attendanceInfo = attendanceMap.get(profile.email) || { attended: false };
    //             return {
    //                 Email: profile.email,
    //                 PhoneNumber: profile.phoneNumber,
    //                 Profession: profile.profession,
    //                 Name: profile.name || '', // Assuming 'name' field exists in profile data
    //                 Attendance: attendanceInfo.attended ? 'Present' : 'Absent',
    //                 AttendanceDetails: attendanceInfo.attended ? `Marked at ${attendanceInfo.timestamp}` : 'N/A' // Add additional details if available
    //             };
    //         });
    
    //         // Convert to CSV using PapaParse
    //         const csv = Papa.unparse(csvData);
    
    //         // Create a blob and trigger download
    //         const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    //         saveAs(blob, `event_${eventId}_bookings.csv`);
    //     } catch (error) {
    //         console.error('Error generating CSV:', error);
    //     }
    // };
    

    const handleDownloadCSV = async (eventId) => {
        try {
            const db = getFirestore();
    
            // Fetch user bookings for the event
            const bookingsRef = collection(db, 'userBookings');
            const bookingsQuery = query(bookingsRef, where('eventId', '==', eventId), where('userConfirmed', '==', true));
            const bookingsSnapshot = await getDocs(bookingsQuery);
    
            const userEmails = bookingsSnapshot.docs.map(doc => doc.data().userEmail);
    
            // Check if userEmails array is not empty
            if (userEmails.length === 0) {
                alert('No user bookings found for this event. CSV download is not available.');
                return; // Exit the function if no users are found
            }
    
            // Fetch user profiles
            const profilesRef = collection(db, 'UserProfileMaster');
            const profilesQuery = query(profilesRef, where('email', 'in', userEmails));
            const profilesSnapshot = await getDocs(profilesQuery);
    
            if (profilesSnapshot.empty) {
                console.warn('No user profiles found for the given user IDs.');
                return;
            }
    
            const userProfiles = profilesSnapshot.docs.map(doc => doc.data());
    
            // Fetch attendance records
            const attendanceRef = collection(db, 'attendance'); // Assuming 'attendanceRecords' is the collection storing attendance
            const attendanceQuery = query(attendanceRef, where('eventId', '==', eventId));
            const attendanceSnapshot = await getDocs(attendanceQuery);
    
            const attendanceMap = new Map();
            attendanceSnapshot.docs.forEach(doc => {
                const data = doc.data();
                attendanceMap.set(data.email, { attended: true, ...data });
            });
    
            // Prepare CSV data with attendance information
            const csvData = userProfiles.map(profile => {
                const attendanceInfo = attendanceMap.get(profile.email) || { attended: false };
                return {
                    Email: profile.email,
                    PhoneNumber: profile.phoneNumber,
                    Profession: profile.profession,
                    Name: profile.name || '', // Assuming 'name' field exists in profile data
                    Attendance: attendanceInfo.attended ? 'Present' : 'Absent',
                    AttendanceDetails: attendanceInfo.attended ? `Marked at ${attendanceInfo.timestamp}` : 'N/A' // Add additional details if available
                };
            });
    
            // Manually create the CSV string
            const csvHeader = Object.keys(csvData[0]).join(',') + '\n';
            const csvRows = csvData.map(row =>
                Object.values(row)
                    .map(value => `"${value}"`) // Enclose values in quotes to handle commas within values
                    .join(',')
            ).join('\n');
    
            const csv = csvHeader + csvRows;
    
            // Create a blob and trigger download
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, `event_${eventId}_bookings.csv`);
        } catch (error) {
            console.error('Error generating CSV:', error);
        }
    };
    

    const handleDownloadICS = (event) => {
        const icsContent = generateICSFile(
            event.eventName,
            moment(event.startTime).format('DD-MM-YYYY'),
            moment(event.startTime).format('HH:mm'),
            moment(event.endTime).diff(moment(event.startTime), 'minutes'),
            event.venue
        );

        const blob = new Blob([icsContent], { type: 'text/calendar' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${event.eventName}.ics`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const handleOpenEditDialog = (event) => {
        setFormValues({
            eventName: event.eventName,
            eventDate: moment(event.startTime).format('YYYY-MM-DD'),
            eventTime: moment(event.startTime).format('HH:mm'),
            duration: event.duration,
            venue: event.venue,
            description: event.description,
            flyerUrl: event.flyerUrl,
            freePaid: event.freePaid,
            onlineOffline: event.onlineOffline,
            speakerName: event.speakerName,
            additionalPoints: event.additionalPoints,


            seatOption: event.seatOption || 'Unlimited',  // New field
            seatCount: event.seatCount || '',  // New field for limited seats
            nomineeOption: 'Single',  // Default to Single
        });
        setAmount(event.freePaid === 'Paid' ? event.amount : '');
        setFlyerPreview(event.flyerUrl);
        setCurrentEventId(event.id);
        setEditMode(true);
        setOpenDialog(true);
    };


    const fetchEvents = async () => {
        try {
            const snapshot = await getDocs(collection(firestore, 'events'));
            const eventsData = snapshot.docs.map(doc => {
                const data = doc.data();
                const startTime = data.startTime && data.startTime.toDate ? data.startTime.toDate() : null;
                const endTime = data.endTime && data.endTime.toDate ? data.endTime.toDate() : null;
                return {
                    id: doc.id,
                    ...data,
                    startTime: data.startTime ? data.startTime.toDate() : null,
                    endTime: data.endTime ? data.endTime.toDate() : null,
                    title: data.eventName, // Use the event name as the title
                    start: startTime ? moment(startTime).toDate() : null,
                    end: endTime ? moment(endTime).toDate() : null,
                    creatorId: data.creatorId, // Fetch creatorId from Firestore
                };
            });
            setEvents(eventsData);
        } catch (error) {
            console.error('Error fetching events:', error);
        }
    };


    useEffect(() => {
        fetchEvents();
    }, []);


    const handleInputChange = async (e) => {
        const { name, value, files } = e.target;
    
        if (name === 'flyer' && files[0]) {
            const file = files[0];
    
            // File Type Validation
            const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!validTypes.includes(file.type)) {
                alert('Only JPG, JPEG, and PNG formats are allowed.');
                return;  // Exit if the file type is invalid
            }
    
            // Handle File Compression or Direct Upload Based on Toggle State
            if (useCompressedImage) {
                const compressedFile = await compressImage(file, 500); // 500KB max size
                setFormValues(prev => ({ ...prev, flyer: compressedFile }));
                setFlyerPreview(URL.createObjectURL(compressedFile)); // Set preview URL
            } else {
                setFormValues(prev => ({ ...prev, flyer: file }));
                setFlyerPreview(URL.createObjectURL(file)); // Set preview URL
            }
        } else {
            // Handle all other form field changes, including eventName
            setFormValues(prev => ({
                ...prev,
                [name]: value  // Allow numbers and letters in eventName
            }));
        }
    
        // Handle amount field based on freePaid value
        if (name === 'freePaid') {
            setFormValues(prev => ({
                ...prev,
                amount: value === 'Free' ? '0' : amount  // Reset amount for 'Free' events
            }));
        }
    
        if (name === 'amount') {
            setAmount(value);
        }
    };
    

    const compressImage = (file, maxSize) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');

                    const maxWidth = 1000;
                    const scaleFactor = maxWidth / img.width;
                    canvas.width = maxWidth;
                    canvas.height = img.height * scaleFactor;

                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                    canvas.toBlob((blob) => {
                        if (blob.size > maxSize * 1024) {
                            console.error('Compressed file is still too large.');
                            resolve(file);
                        } else {
                            const newFile = new File([blob], file.name, {
                                type: file.type,
                                lastModified: Date.now(),
                            });
                            resolve(newFile);
                        }
                    }, file.type, 0.7);
                };
            };
            reader.onerror = (error) => reject(error);
        });
    };

    const handleRejectEvent = async (eventId) => {
        try {
            await deleteDoc(doc(firestore, 'events', eventId));
            setEvents(events.filter(event => event.id !== eventId));
        } catch (error) {
            console.error('Error rejecting event:', error);
        }
    };

    const handleAddEvent = async () => {
        try {
            const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            const validTextRegex = /^[a-zA-Z0-9\s]*$/; // Allows letters, digits, and spaces

            const validNumberRegex = /^[0-9]*$/; // Allows only digits
    
            // Validate flyer type
            if (formValues.flyer && !validTypes.includes(formValues.flyer.type)) {
                alert('Invalid file type. Please upload a JPG, JPEG, or PNG image.');
                return; // Stop submission if invalid
            }
    
            // Validate event name
            if (!validTextRegex.test(formValues.eventName) || formValues.eventName.length > 100) {
                alert('Event name can only contain letters and should be less than 100 characters.');
                return;
            }
    
            // Validate venue
            if (!validTextRegex.test(formValues.venue) || formValues.venue.length > 200) {
                alert('Venue can only contain letters and spaces, and should be less than 200 characters.');
                return;
            }
    
            // Validate description
            if (formValues.description.length > 500) {
                alert('Description should be less than 500 characters.');
                return;
            }
    
            // Validate duration (minimum 1 minute, maximum 600 minutes)
            if (!validNumberRegex.test(formValues.duration) || formValues.duration < 1 || formValues.duration > 600) {
                alert('Duration must be a number between 1 and 600 minutes.');
                return;
            }
    
            // Validate seat count (if applicable)
            if (formValues.seatOption === 'Limited' && (!validNumberRegex.test(formValues.seatCount) || formValues.seatCount < 1)) {
                alert('Seat count must be a positive number.');
                return;
            }
    
            const eventDateTime = moment(`${formValues.eventDate} ${formValues.eventTime}`, 'YYYY-MM-DD HH:mm').toDate();
            const startTime = eventDateTime;
            const endTime = new Date(startTime.getTime() + formValues.duration * 60 * 1000);
    
            // Get the current date and time
            const currentDate = new Date();
            const today = currentDate.toISOString().split('T')[0]; // Format: 'YYYY-MM-DD'
    
            // If the event date is today, check the time
            if (formValues.eventDate === today && startTime < currentDate) {
                alert('Event time cannot be in the past.');
                return; // Stop submission if time is invalid
            }
    
            // Check if the event date is in the past
            if (startTime < currentDate) {
                alert('Event date and time cannot be in the past.');
                return; // Stop submission if the event date is invalid
            }
    
            if (isNaN(startTime.getTime())) {
                alert('Invalid date or time format.');
                return;
            }
    
            let flyerUrl = formValues.flyerUrl;
    
            if (formValues.flyer && formValues.flyer !== flyerUrl) {
                const flyerRef = storageRef(storage, `flyers/${formValues.flyer.name}`);
                await uploadBytes(flyerRef, formValues.flyer);
                flyerUrl = await getDownloadURL(flyerRef);
            }
    
            const eventData = {
                eventName: formValues.eventName || '',
                description: formValues.description || '',
                flyerUrl: flyerUrl || '',
                startTime: startTime || new Date(),
                endTime: endTime || new Date(),
                duration: formValues.duration || 60,
                venue: formValues.venue || '',
                freePaid: formValues.freePaid || 'Free',
                amount: formValues.freePaid === 'Paid' ? amount : '0',
                onlineOffline: formValues.onlineOffline || 'Online',
                speakerName: formValues.speakerName || '',
                additionalPoints: formValues.additionalPoints || '',
                seatOption: formValues.seatOption || 'Unlimited',
                seatCount: formValues.seatOption === 'Limited' ? formValues.seatCount : '1000',
                nomineeOption: formValues.nomineeOption || 'Single',
                creatorId: currentUser ? currentUser.uid : '', // Ensure UID is valid
            };
    
            if (editMode) {
                await updateDoc(doc(firestore, 'events', currentEventId), eventData);
            } else {
                await addDoc(collection(firestore, 'events'), eventData);
            }
    
            // Reset form and state
            setFormValues({
                eventName: '', eventDate: '', eventTime: '',
                duration: 60, venue: '', description: '',
                flyer: null, flyerUrl: '',
                freePaid: 'Free', onlineOffline: 'Online', speakerName: '', additionalPoints: '',
                seatOption: 'Unlimited',
                seatCount: '',
            });
            setFlyerPreview(null);
            setEditMode(false);
            setCurrentEventId(null);
            setOpenDialog(false);
            setOpenSnackbar(true);
            fetchEvents();
        } catch (error) {
            console.error('Error saving event:', error);
        }
    };
    
    
    



    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => {
        setOpenDialog(false);
        setEditMode(false);
        setCurrentEventId(null);
        setFlyerPreview(null);
    };

    const handleOriginalImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormValues(prev => ({ ...prev, flyer: file }));
            setFlyerPreview(URL.createObjectURL(file));
        }
    };


    const sortedEvents = [...events].sort((a, b) => new Date(a.startTime) - new Date(b.startTime));



    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Check for valid file types
            const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            if (!validTypes.includes(file.type)) {
                alert('Only JPG, JPEG, and PNG formats are allowed.');
                setFormValues((prevValues) => ({ ...prevValues, flyer: null })); // Clear the file
                setFlyerPreview(null); // Clear the preview
                return;
            }

            // If valid, set the file and preview
            setFormValues((prevValues) => ({ ...prevValues, flyer: file }));
            setFlyerPreview(URL.createObjectURL(file)); // Generate image preview
            console.log('File type:', file.type); // Verify file type in console
        }
    };


    const handleConfirmAction = async () => {
        if (!currentUser || !selectedEvent) return;
    
        // Optimistic UI update
        const optimisticBookings = { ...bookings };
        const bookingRefId = `${currentUser.email}_${selectedEvent.id}`;
    
        if (confirmationAction === 'book') {
            optimisticBookings[selectedEvent.id] = true; // Optimistically mark the event as booked
        } else if (confirmationAction === 'cancel') {
            optimisticBookings[selectedEvent.id] = false; // Optimistically mark the event as cancelled
        }
    
        // Set the updated optimistic state
        setBookings(optimisticBookings);
    
        // Close the dialog immediately for a faster user experience
        setOpenConfirmationDialog(false);
        handleCloseEventDialog();
    
        const email = currentUser.email;
        const apiKey = "qwertyuiop";
        const orderId = bookingRefId;
        const eventName = selectedEvent.eventName;
        const eventDate = moment(selectedEvent.startTime).format('DD-MM-YYYY');
        const eventTime = moment(selectedEvent.startTime).format('HH:mm');
        const eventDuration = moment(selectedEvent.endTime).diff(moment(selectedEvent.startTime), 'minutes');
        const eventVenue = selectedEvent.venue;
    
        const userProfileRef = doc(firestore, 'UserProfileMaster', currentUser.uid);
        const userProfileSnap = await getDoc(userProfileRef);
    
        if (!userProfileSnap.exists()) {
            console.error("User profile data not found.");
            return;
        }
    
        const { phoneNumber, profession } = userProfileSnap.data();
    
        setLoading(true);
    
        try {
            const bookingRef = doc(firestore, 'userBookings', bookingRefId);
    
            if (confirmationAction === 'book') {
                await setDoc(bookingRef, {
                    userEmail: currentUser.email,
                    eventId: selectedEvent.id,
                    userConfirmed: true,
                    numberOfSeats: selectedSeats,
                    phoneNumber: phoneNumber || '',
                    profession: profession || '',
                });
    
                sendOrderConfirmationEmail(email, apiKey, orderId, eventName, eventDate, eventTime, eventDuration, eventVenue);
            } else if (confirmationAction === 'cancel') {
                await updateDoc(bookingRef, { userConfirmed: false });
    
                sendOrderErrorEmail(email, apiKey, orderId, 'Your booking has been cancelled.');
            }
    
            // Fetch updated bookings from Firestore
            await fetchUserBookings();
    
        } catch (error) {
            console.error(`Error during ${confirmationAction}:`, error);
    
            // Revert optimistic update in case of an error
            const revertedBookings = { ...bookings };
            revertedBookings[selectedEvent.id] = confirmationAction === 'book' ? false : true;
            setBookings(revertedBookings);
    
            sendOrderErrorEmail(email, apiKey, orderId, error.message);
        } finally {
            setLoading(false);
        }
    };
    
    
    

    const handleCancelAction = () => {
        setOpenConfirmationDialog(false);
    };

    const handleShareEvent = (event) => {
        const eventUrl = `${window.location.origin}/event/${event.id}`; // Generate the dynamic event URL

        if (navigator.share) {
            navigator.share({
                title: event.eventName,
                text: `Check out this event: ${event.eventName}`,
                url: eventUrl,
            })
                .then(() => console.log('Event shared successfully!'))
                .catch((error) => console.error('Error sharing event:', error));
        } else {
            // Fallback: copy the link to the clipboard
            navigator.clipboard.writeText(eventUrl)
                .then(() => {
                    alert('Event link copied to clipboard!');
                })
                .catch((error) => console.error('Error copying link to clipboard:', error));
        }
    };
    // Add a useEffect hook to manage state updates and visibility changes
    useEffect(() => {
        if (bookings[selectedEvent?.id]) {
            setOpenSnackbar(false); // Hide snackbar for bookings, if visible.
        }
    }, [bookings, selectedEvent]);
    console.log(  auth.currentUser.uid)
  // Fetch events hosted by the current user
  const fetchHostEvents = async () => {
    try {
      const q = query(collection(firestore, 'events'), where('creatorId', '==', currentUser.uid));
      const snapshot = await getDocs(q);
      const hostedEvents = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setHostEvents(hostedEvents);
    } catch (error) {
      console.error('Error fetching host events:', error);
    }
  };

  // Fetch events booked by the current user
  const fetchBookedEvents = async () => {
    try {
      const q = query(collection(firestore, 'bookings'), where('userId', '==', currentUser.uid));
      const snapshot = await getDocs(q);
      const bookedEventsData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      setBookedEvents(bookedEventsData);
    } catch (error) {
      console.error('Error fetching booked events:', error);
    }
  };

  // Effect to fetch events based on the active tab
  useEffect(() => {
    setLoading(true);
    if (tabValue === 0) {
      fetchHostEvents().then(() => setLoading(false));
    } else {
      fetchBookedEvents().then(() => setLoading(false));
    }
  }, [tabValue]);

  // Tab change handler
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

   // Filtered events for each tab based on the user's role

const createdEvents = events
  .filter(event => event.creatorId === auth.currentUser.uid)  // Filter events created by the current user
  .map(event => ({
    title: event.eventName,
    start: new Date(event.startTime),
    end: new Date(event.endTime),
  }));


   const bookedEventsCal = events.filter(event => bookings[event.id] === true).map(event => ({
    title: event.eventName,
    start: new Date(event.startTime),
    end: new Date(event.endTime),
  }));
 

const renderEvents = (events, isHostView, showTableView) => {
    return showTableView ? (
       <TableContainer component={Paper} style={{ marginTop: '20px' }}>
              <Table>
                  <TableHead>
                      <TableRow>
                          <TableCell>Thumbnail Flyer</TableCell>
                          <TableCell>Event Name</TableCell>
                          <TableCell>Date</TableCell>
                          <TableCell>Time</TableCell>
                          <TableCell>Duration (mins)</TableCell>
                          <TableCell>Venue</TableCell>
                          <TableCell>Free/Paid</TableCell>
                          <TableCell>Online/Offline</TableCell>
                          <TableCell>Speaker Name</TableCell>
                          <TableCell>Capacity</TableCell>
                          <TableCell>Actions</TableCell>
                      </TableRow>
                  </TableHead>
                  <TableBody>
                      {sortedEvents
                          .filter(event => isHostView 
                              ? event.creatorId === auth.currentUser.uid  // Host view: show only created events
                              : true  // Booked events: show all events
                          )
                          .map(event => (
                              <TableRow key={event.id}>
                                  <TableCell>
                                      <img src={event.flyerUrl} alt="Flyer" style={{ width: '100px', height: 'auto' }} />
                                  </TableCell>
                                  <TableCell>{event.eventName}</TableCell>
                                  <TableCell>{moment(event.startTime).format('D MMM, YYYY')}</TableCell>
                                  <TableCell>{moment(event.startTime).format('HH:mm')}</TableCell>
                                  <TableCell>{event.duration}</TableCell>
                                  <TableCell>{event.venue}</TableCell>
                                  <TableCell>{event.freePaid}</TableCell>
                                  <TableCell>{event.onlineOffline}</TableCell>
                                  <TableCell>{event.speakerName}</TableCell>
                                  <TableCell>{event.seatOption === 'Limited' ? `${event.seatCount} Seats` : 'Unlimited Seats'}</TableCell>
                                  <TableCell>
                                      {isHostView ? (
                                          <>
                                              <IconButton color="primary" onClick={() => handleOpenEditDialog(event)}>
                                                  <EditIcon />
                                              </IconButton>
                                              <IconButton color="error" onClick={() => handleRejectEvent(event.id)}>
                                                  <DeleteIcon />
                                              </IconButton>
                                              <IconButton color="default" onClick={(e) => { e.stopPropagation(); handleDownloadCSV(event.id); }}>
                                                  <DownloadIcon />
                                              </IconButton>
                                              <IconButton color="primary" onClick={(e) => { 
    e.stopPropagation(); // Prevent event propagation
    downloadQRCodeWrapper(event.id); 
}}>
    <QrCodeIcon />
</IconButton>
                                          </>
                                      ) : (
                                          <>
                                              {bookings[event.id] ? (
                                                  <>
                                                      <IconButton color="error" onClick={() => handleConfirmationDialog('cancel', event)}>
                                                          <CancelIcon />
                                                      </IconButton>
                                                      <IconButton color="primary" onClick={() => handleDownloadICS(event)}>
                                                          <InsertInvitationIcon />
                                                      </IconButton>
                                                      <IconButton color="primary" onClick={() => handleShareEvent(event)}>
                                                          <ShareIcon />
                                                      </IconButton>
                                                  </>
                                              ) : (
                                                  <Button size="small" color="primary" onClick={(e) => { e.stopPropagation(); handleConfirmationDialog('book', event); }}>
                                                      Book Now
                                                  </Button>
                                              )}
                                          </>
                                      )}
                                  </TableCell>
                              </TableRow>
                          ))}
                  </TableBody>
              </Table>
          </TableContainer>
    ) : (
      <Grid container spacing={2} sx={{ marginTop: '20px' }}>
              {sortedEvents
                  .filter(event => isHostView 
                      ? event.creatorId === auth.currentUser.uid  // Host view: show only events created by the current user
                      : true  // Booked events: show all events, whether booked or not
                  )
                  .slice(0, visibleEvents)
                  .map(event => (
                      <Card key={event.id} style={{ width: '100%', maxWidth: '300px', margin: '20px' }} onClick={() => handleOpenEventDialog(event)}>
                          <CardMedia
                              component="img"
                              height="140"
                              image={event.flyerUrl}
                              alt="Flyer"
                          />
                          <CardContent>
                              <Typography gutterBottom variant="h5" component="div">
                                  {event.eventName}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                  {event.description}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                  {moment(event.startTime).format('D MMM, YYYY')} at {moment(event.startTime).format('HH:mm')}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                  {event.venue}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                  {event.freePaid} | {event.onlineOffline}
                              </Typography>
                              <Typography variant="body2" color="text.secondary">
                                  {event.seatOption === 'Limited' ? `Seats: ${event.seatCount}` : 'Unlimited Seats'}
                              </Typography>
                          </CardContent>
  
                          <CardActions>
  {isHostView ? (
    <>
      <IconButton color="primary" onClick={(e) => { e.stopPropagation(); handleOpenEditDialog(event); }}>
        <EditIcon />
      </IconButton>
      <IconButton color="error" onClick={(e) => { e.stopPropagation(); handleRejectEvent(event.id); }}>
        <DeleteIcon />
      </IconButton>
      <IconButton color="default" onClick={(e) => { e.stopPropagation(); handleDownloadCSV(event.id); }}>
        <DownloadIcon />
      </IconButton>
      <IconButton color="primary" onClick={(e) => { 
    e.stopPropagation(); // Prevent event propagation
    downloadQRCodeWrapper(event.id); 
}}>
    <QrCodeIcon />
</IconButton>

    </>
  ) : (
    <>
      {bookings[event.id] ? (
        <>
          <IconButton color="error" onClick={(e) => { e.stopPropagation(); handleConfirmationDialog('cancel', event); }}>
            <CancelIcon />
          </IconButton>
          <IconButton color="primary" onClick={() => handleDownloadICS(event)}>
            <InsertInvitationIcon />
          </IconButton>
          <IconButton color="primary" onClick={() => handleShareEvent(event)}>
            <ShareIcon />
          </IconButton>
        </>
      ) : (
        <Button size="small" color="primary" onClick={(e) => { e.stopPropagation(); handleConfirmationDialog('book', event); }}>
          Book Now
        </Button>
      )}
    </>
  )}
</CardActions>

                      </Card>
                  ))}
                   <Dialog open={openEventDialog} onClose={handleCloseEventDialog}>
                   <DialogTitle>
                       {selectedEvent?.eventName}
                       <Button
                          onClick={handleCloseEventDialog}
                          style={{ position: 'absolute', top: 8, right: 8 }}
                      >
                          <CloseIcon />
                      </Button>
                  </DialogTitle>
                  <DialogContent>
                      <img
                          src={selectedEvent?.flyerUrl}
                          alt={selectedEvent?.eventName}
                          style={{ width: '100%', maxHeight: '200px', objectFit: 'contain', marginBottom: '20px' }}
                      />
                      <Typography variant="body1" gutterBottom>
                          {moment(selectedEvent?.startTime).format('DD-MM-YYYY')} - {moment(selectedEvent?.startTime).format('HH:mm')} - {selectedEvent?.venue}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" gutterBottom>
                          Duration: {moment(selectedEvent?.endTime).diff(moment(selectedEvent?.startTime), 'minutes')} mins
                      </Typography>
                      <Typography variant="body2" color="textSecondary" gutterBottom>
                          {selectedEvent?.description}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" gutterBottom>
                          Free/Paid: {selectedEvent?.freePaid}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" gutterBottom>
                          Online/Offline: {selectedEvent?.inlineOffline}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" gutterBottom>
                          Speaker Name: {selectedEvent?.speakerName}
                      </Typography>
                      <Typography variant="body2" color="textSecondary" gutterBottom>
                          Additional Points: {selectedEvent?.additionalPoints}
                      </Typography>
                  </DialogContent>
                  <DialogActions>
                      <Button size="small" color="primary" onClick={handleCloseEventDialog}>
                          Close
                      </Button>
                  </DialogActions>
                  <DialogActions>
                      {bookings[selectedEvent?.id] ? (
                          <IconButton
                              color="secondary"
                              onClick={() => handleConfirmationDialog('cancel', selectedEvent)}
                          >
                              <CancelIcon />
                          </IconButton>
                      ) : (
                          <Button
                              size="small"
                              color="primary"
                              onClick={() => handleConfirmationDialog('book', selectedEvent)}
                          >
                              Book Now!
                          </Button>
                      )}
                  </DialogActions>
  
              </Dialog>
  
  
              <Dialog open={openConfirmationDialog} onClose={handleCancelAction}>
                  <DialogTitle>
                      {confirmationAction === 'book' ? 'Are you sure you want to book this event?' : 'Are you sure you want to cancel this booking?'}
                  </DialogTitle>
                  <DialogActions>
                      <Button onClick={handleCancelAction} color="secondary">
                          Cancel
                      </Button>
                      <Button onClick={handleConfirmAction} color="primary">
                          Confirm
                      </Button>
                  </DialogActions>
              </Dialog>
          </Grid>
    );
  };
  
// Fetch all events from Firestore
useEffect(() => {
    const fetchAllEvents = async () => {
        
        const eventSnapshot = await getDocs(collection(firestore, 'events'));
        const events = eventSnapshot.docs.map(doc => ({
            id: doc.id,
            
            ...doc.data()
        }));
        setAllEvents(events);  // Store all events in state
    };

    fetchAllEvents();
}, []);
const [allEvents, setAllEvents] = useState([]); // Store all events

console.log('Created Events:', createdEvents);
console.log('All Events:', allEvents);

  return (
    <Container>
      {/* Title */}
      <Typography variant="h5" sx={{ marginBottom: '20px', textAlign: 'center' }}>
        Events
      </Typography>
      <div style={{ position: 'fixed', bottom: '18px', right: '16px' }}>
                <Fab
                    color="primary"
                    onClick={handleOpenDialog}
                    style={{
                        width: '56px',   // Set width equal to height for a circular button
                        height: '56px',  // Height remains the same
                        borderRadius: '50%'  // Make it fully circular by setting borderRadius to 50%
                    }}
                >
                    <AddIcon />
                </Fab>
            </div>
      {/* Tabs */}
      <Tabs value={tabValue} onChange={handleTabChange} centered>
        <Tab label="Host Event" />
        <Tab label="Book Event" />
      </Tabs>
  {/* Host Event Tab */}
  <TabPanel value={tabValue} index={0}>
  <Box sx={{ marginTop: '20px', padding: '20px' }}>
  {/* View selection buttons */}
  <Grid container display="flex" justifyContent="center" alignItems="center">
    {/* Grid View Button */}
    <IconButton 
      color={view === 'grid' ? 'primary' : 'default'} 
      onClick={() => setView('grid')}
    >
      <GridViewIcon />
    </IconButton>

    {/* List View Button */}
    <IconButton 
      color={view === 'list' ? 'primary' : 'default'} 
      onClick={() => setView('list')}
    >
      <ListIcon />
    </IconButton>

    {/* Calendar View Button */}
    <IconButton
      color={view === 'calendar' ? 'primary' : 'default'}
      onClick={() => setView('calendar')}
    >
      <CalendarTodayIcon />
    </IconButton>
  </Grid>

  {/* Render the views based on the selected option */}
  {view === 'grid' && renderEvents(createdEvents, true, false)} {/* Grid View for created events */}
  {view === 'list' && renderEvents(createdEvents, true, true)} {/* List View for created events */}

  {/* Calendar View for Host's Created Events */}
  {view === 'calendar' && (
    <Calendar
      localizer={localizer}
      events={createdEvents} // Pass the filtered events
      startAccessor="start"
      endAccessor="end"
      style={{ height: 500, margin: '20px 0' }}
    />
  )}
</Box>

    </TabPanel>

    <TabPanel value={tabValue} index={1}>
    <Box sx={{ marginTop: '20px', padding: '20px' }}>
  {/* Toggle Switch for View Selection and Calendar Toggle */}
  <Grid container display="flex" justifyContent="center" alignItems="center">
    {/* Grid (Card) View Icon */}
    <IconButton 
      color={view === 'grid' ? 'primary' : 'default'} 
      onClick={() => setView('grid')} // Set Grid (Card) View
    >
      <GridViewIcon />
    </IconButton>

    {/* List (Table) View Icon */}
    <IconButton 
      color={view === 'list' ? 'primary' : 'default'} 
      onClick={() => setView('list')} // Set List (Table) View
    >
      <ListIcon />
    </IconButton>

    {/* Calendar View Icon */}
    <IconButton 
      color={view === 'calendar' ? 'primary' : 'default'} 
      onClick={() => setView('calendar')} // Set Calendar View
    >
      <CalendarTodayIcon />
    </IconButton>
  </Grid>

  {/* Conditional Rendering for Views */}

  {/* Grid (Card) View */}
  {view === 'grid' && renderEvents(allEvents, false, false)} {/* Pass parameters for Card (Grid) view */}

  {/* List (Table) View */}
  {view === 'list' && renderEvents(allEvents, false, true)} {/* Pass parameters for Table (List) view */}

  {/* Calendar View */}
  {view === 'calendar' && (
    
    <Calendar
      localizer={localizer}
      events={bookedEventsCal} // Pass the filtered events
      startAccessor="start"
      endAccessor="end"
      style={{ height: 500, margin: '20px 0' }}
      
    />


  )}
  
</Box>


    </TabPanel>
      

      <Dialog open={openDialog} onClose={handleCloseDialog}>
                <DialogTitle>Event Details</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        name="eventName"
                        label="Event Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={formValues.eventName}
                        onChange={handleInputChange}
                    />
                    <TextField
    margin="dense"
    label="Event Date"
    type="date"
    fullWidth
    name="eventDate"
    value={formValues.eventDate}
    onChange={handleInputChange}
    InputLabelProps={{ shrink: true }}
    inputProps={{
        min: new Date().toISOString().split("T")[0]  // Restrict to today and future dates
    }}
/>
<TextField
    margin="dense"
    label="Event Time"
    type="time"
    fullWidth
    name="eventTime"
    value={formValues.eventTime}
    onChange={handleInputChange}
    InputLabelProps={{ shrink: true }}
    inputProps={{
        // Check if selected date is today
        min: formValues.eventDate === new Date().toISOString().split("T")[0]
          ? new Date().toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })
          : '00:00'  // Allow all times for future dates
    }}
/>


                    <TextField
                        margin="dense"
                        name="duration"
                        label="Duration (minutes)"
                        type="number"
                        fullWidth
                        variant="outlined"
                        value={formValues.duration}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="venue"
                        label="Venue"
                        type="text"
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={2} // Set to 2 lines
                        value={formValues.venue}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="speakerName"
                        label="Speaker Name"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={formValues.speakerName}
                        onChange={handleInputChange}
                    />
                    <TextField
                        margin="dense"
                        name="description"
                        label="Description"
                        type="text"
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={2} // Set to 2 lines
                        value={formValues.description}
                        onChange={handleInputChange}
                    />

                    <TextField
                        margin="dense"
                        name="freePaid"
                        label="Free/Fees"
                        select
                        fullWidth
                        value={formValues.freePaid}
                        onChange={handleInputChange}
                        SelectProps={{ native: true }}
                    >
                        <option value="Free">Free</option>
                        <option value="Fees">Fees</option>
                    </TextField>
                    {formValues.freePaid === 'Fees' && (
                        <TextField
                            margin="dense"
                            name="amount"
                            label="Amount"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={amount}
                            onChange={handleInputChange}
                        />
                    )}

                    <TextField
                        margin="dense"
                        name="onlineOffline"
                        label="Online/Offline"
                        select
                        fullWidth
                        value={formValues.onlineOffline}
                        onChange={handleInputChange}
                        SelectProps={{ native: true }}
                    >
                        <option value="Online">Online</option>
                        <option value="Offline">Offline</option>
                    </TextField>

                    <TextField
                        margin="dense"
                        name="seatOption"
                        label="Seat Option"
                        select
                        fullWidth
                        value={formValues.seatOption}
                        onChange={handleInputChange}
                        SelectProps={{ native: true }}
                    >
                        <option value="Unlimited">Unlimited Seats</option>
                        <option value="Limited">Limited Seats</option>
                    </TextField>

                    {formValues.seatOption === 'Limited' && (
                        <TextField
                            margin="dense"
                            name="seatCount"
                            label="Number of Seats"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={formValues.seatCount}
                            onChange={handleInputChange}
                        />
                    )}
                    <TextField
                        margin="dense"
                        name="nomineeOption"
                        label="Nominee Option"
                        select
                        fullWidth
                        value={formValues.nomineeOption}
                        onChange={handleInputChange}
                        SelectProps={{ native: true }}
                    >
                        <option value="Single">Single Nominee</option>
                        <option value="Multiple">Multiple Nominees</option>
                    </TextField>


                    <TextField
                        margin="dense"
                        name="additionalPoints"
                        label="Additional Points"
                        type="text"
                        fullWidth
                        variant="outlined"
                        multiline
                        rows={2} // Set to 2 lines
                        value={formValues.additionalPoints}
                        onChange={handleInputChange}
                    />
                    
                    <input
                        name="flyer"
                        type="file"
                        accept="image/jpeg, image/png, image/jpg" // Specify valid formats here
                        onChange={handleFileChange} // Use the file-specific handler
                        style={{ marginBottom: '16px' }}
                    />

                    {flyerPreview && <img src={flyerPreview} alt="Flyer Preview" style={{ width: '100px', height: 'auto', marginBottom: '16px' }} />}
                    <FormControlLabel
                        control={<Switch checked={useCompressedImage} onChange={(e) => setUseCompressedImage(e.target.checked)} />}
                        label="Upload Compressed Image"
                    />


                </DialogContent>
              
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">Cancel</Button>
                    <Button
                        onClick={handleAddEvent}
                        color="primary"
                        disabled={
                            // Disable if flyer is present and is not of a valid type
                            formValues.flyer && !['image/jpeg', 'image/png', 'image/jpg'].includes(formValues.flyer.type)
                        }
                    >
                        {editMode ? 'Save' : 'Add Event'}
                    </Button>
                </DialogActions>


            </Dialog>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={() => setOpenSnackbar(false)}
                message="Event added successfully!"
            />

            {visibleEvents < events.length && (
                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <Button variant="contained" color="primary" onClick={loadMoreEvents}>
                        Load More
                    </Button>
                </Box>
            )}
    </Container>
  );
};

// TabPanel component to show or hide tabs content based on index
function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default UploadEvents;